<template>
    <div class="Comments">
        <div class="pageTitle">Received Reviews</div>
        <!-- Reviews列表 -->
        <div class="commentsList">
            <div class="commentsItem" v-for="item in commentsData" :key="item.comment_id">
                <div class="rows">
                    <ShopStar :num="item.score"/>
                    <div class="Publisher">
                        <div>{{ item.nickName || 'Username' }}</div>
                        <div class="round"></div>
                        <div>{{ formatDate(item.create_time) }}</div>
                    </div>
                </div>
                <div class="serviceName">{{ (item.service && item.service.name) || 'Service Name' }}</div>
                <div class="serviceProvider">{{ (item.user && item.user.nickName) || 'Staff' }}</div>
                <div class="commentContent">{{ item.content }}</div>
                <!-- Reviews图片 -->
                <div class="commentImages" v-if="item.image && item.image.length > 0">
                    <img v-for="img in item.image" :key="img.id" :src="getUrl(img.file_path)" @click="previewImage(getUrl(img.file_path))" />
                </div>
                <!-- Additional Review -->
                <div class="addcomments" v-if="item.addContent">
                    <div class="addTitle">Additional Review</div>
                    <div class="addDesc">Booksy ensures that reviews tagged as "Verified Booksy User" are posted by registered users who actually booked with the provider. Reviews can be submitted only after the service is completed.</div>
                    <div class="addMeta">
                        <span>{{ item.nickName || 'Username' }}</span>
                        <span class="round"></span>
                        <span>{{ formatDate(item.create_time) }}</span>
                    </div>
                </div>
                <van-divider />
            </div>
        </div>
        <!-- 空状态 -->
        <van-empty v-if="commentsData.length === 0 && !loading" description="No reviews" />
        <!-- 加载状态 -->
        <van-loading v-if="loading" type="spinner" size="24px" vertical>Loading...</van-loading>
    </div>
</template>
<script>
import ShopStar from '@/components/Shop/ShopStar.vue'
import { ImagePreview } from 'vant'
import myMixin from '@/utils/myMixin'
export default {
    name:'Comments',
    mixins: [myMixin],
    props:{
        shop_supplier_id:{
            type: [String, Number],
            default:''
        }
    },
    data(){
        return {
            commentsData:[],
            loading: false,
            queryForm:{
                shop_supplier_id: '',
                page:1,
                list_rows:10
            }
        }
    },
    components:{
        ShopStar
    },
    created(){
        this.queryForm.shop_supplier_id = this.shop_supplier_id
        this.getSupplierComment()
    },
    methods:{
        getSupplierComment(){
            this.loading = true
            this.$api.getSupplierComment(this.queryForm).then(res=>{
                if(res.code == 1 && res.data && res.data.list){
                    this.commentsData = res.data.list.data || []
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        formatDate(dateStr){
            if(!dateStr) return ''
            const date = new Date(dateStr)
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            return `${year}-${month}-${day}`
        },
        previewImage(url){
            ImagePreview([url])
        }
    }
}
</script>
<style lang="scss" scoped>
    .Comments{
        width: 100%;
        padding: 0 1rem;
        box-sizing: border-box;
        font-size: .875rem;
        .pageTitle{
            font-size: 1.125rem;
            font-weight: 600;
            color: #333;
            padding: 1rem 0 0.25rem 0;
        }
        .commentsList{
            .commentsItem{
                margin-top: 1rem;
                .rows{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 0.5rem;
                }
                .Publisher{
                    display: flex;
                    align-items: center;
                    font-size: .75rem;
                    color: #999;
                    gap: 0.25rem;
                    .round{
                        width: 3px;
                        height: 3px;
                        border-radius: 100%;
                        background: #999;
                    }
                }
                .serviceName{
                    font-size: .875rem;
                    font-weight: 500;
                    color: #333;
                    margin-bottom: 0.25rem;
                }
                .serviceProvider{
                    font-size: .75rem;
                    color: #999;
                    margin-bottom: 0.5rem;
                }
                .commentContent{
                    font-size: .875rem;
                    color: #333;
                    line-height: 1.5;
                    margin-bottom: 0.5rem;
                }
                .commentImages{
                    display: flex;
                    gap: 0.5rem;
                    margin-bottom: 0.5rem;
                    flex-wrap: wrap;
                    img{
                        width: 4rem;
                        height: 4rem;
                        border-radius: 0.25rem;
                        object-fit: cover;
                        cursor: pointer;
                    }
                }
                .addcomments{
                    background: #F5F5F5;
                    border-radius: .5rem;
                    padding: 0.75rem;
                    box-sizing: border-box;
                    margin-top: 0.5rem;
                    .addTitle{
                        font-size: .875rem;
                        font-weight: 500;
                        color: #333;
                        margin-bottom: 0.5rem;
                    }
                    .addDesc{
                        font-size: .75rem;
                        color: #999;
                        line-height: 1.5;
                        margin-bottom: 0.5rem;
                    }
                    .addMeta{
                        display: flex;
                        align-items: center;
                        font-size: .75rem;
                        color: #999;
                        gap: 0.25rem;
                        justify-content: flex-end;
                        .round{
                            width: 3px;
                            height: 3px;
                            border-radius: 100%;
                            background: #999;
                        }
                    }
                }
            }
        }
    }
</style>
